import { useEffect, useState } from "react";

import { SubscriptionTier } from "@repo/ui/pricing-hooks";
import { useRemoteConfig } from "@shapr3d/frontend-lib";

import { CancellationSurveyModal } from "../CancellationSurveyModal/CancellationSurveyModal";
import { CancellationWarningModal } from "../CancellationWarningModal/CancellationWarningModal";
import { SubscriptionCancelModal } from "../SubscriptionCancelModal/SubscriptionCancelModal";

export const CancellationFlow: React.FC<{
  open: boolean;
  onClose: () => void;
  onCancelSubscription: () => void;
  isLoading: boolean;
  editorSeatCount: number;
  isSubscriptionInGracePeriod: boolean;
  subscriptionExpirationDate: string;
  subscriptionTier: SubscriptionTier;
}> = ({
  open,
  onClose,
  onCancelSubscription,
  isLoading,
  editorSeatCount,
  isSubscriptionInGracePeriod,
  subscriptionExpirationDate,
  subscriptionTier,
}) => {
  const cancellationWarningFlag = useRemoteConfig("web_cancellation_warning-cd");
  const isFlagLoading = cancellationWarningFlag === undefined;
  const showWarning = cancellationWarningFlag === "treatment";

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isSurveyOpen, setIsSurveyOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setIsConfirmOpen(true);
      setIsSurveyOpen(false);
    } else {
      setIsConfirmOpen(false);
      setIsSurveyOpen(false);
    }
  }, [open]);

  const handleConfirmClose = () => {
    setIsConfirmOpen(false);
    // Only notify parent if we're not transitioning to the survey
    if (!isSurveyOpen) onClose();
  };

  const handleConfirmCTA = () => {
    setIsConfirmOpen(false);
    setIsSurveyOpen(true);
  };

  return (
    <>
      {showWarning ? (
        <CancellationWarningModal
          open={isConfirmOpen}
          onClose={handleConfirmClose}
          isLoading={isLoading || isFlagLoading}
          subscriptionExpirationDate={subscriptionExpirationDate}
          subscriptionTier={subscriptionTier}
          onCTA={handleConfirmCTA}
        />
      ) : (
        <SubscriptionCancelModal
          open={isConfirmOpen}
          onClose={handleConfirmClose}
          isLoading={isLoading || isFlagLoading}
          editorSeatCount={editorSeatCount}
          isSubscriptionInGracePeriod={isSubscriptionInGracePeriod}
          subscriptionExpirationDate={subscriptionExpirationDate}
          subscriptionTier={subscriptionTier}
          onCTA={handleConfirmCTA}
        />
      )}
      <CancellationSurveyModal
        open={isSurveyOpen}
        onClose={() => {
          setIsSurveyOpen(false);
          onClose();
        }}
        onCancelSubscription={onCancelSubscription}
        isLoading={isLoading}
        subscriptionTier={subscriptionTier}
        subscriptionExpirationDate={subscriptionExpirationDate}
      />
    </>
  );
};
